var map = {
	"./i18n/ar.json": [
		37665,
		"src_app_shared_components_backup_i18n_ar_json"
	],
	"./i18n/en-CA.json": [
		4696,
		"src_app_shared_components_backup_i18n_en-CA_json"
	],
	"./i18n/en-US.json": [
		26306,
		"src_app_shared_components_backup_i18n_en-US_json"
	],
	"./i18n/es-MX.json": [
		7854,
		"src_app_shared_components_backup_i18n_es-MX_json"
	],
	"./i18n/fr-CA.json": [
		47807,
		"src_app_shared_components_backup_i18n_fr-CA_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 20211;
module.exports = webpackAsyncContext;